module.exports = __webpack_public_path__ + "static/media/1.43421d9.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/views/index/img/1.mp4
// module id = PFOP
// module chunks = 1